/* 🤖 this file was generated by svg-to-ts */
export const emperorIconInterfaceAlertTriangle1: {
  name: 'interface_alert_triangle_1';
  data: string;
} = {
  name: 'interface_alert_triangle_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M21.895 20.553l-9-18c-.34-.677-1.45-.677-1.79 0l-9 18c-.16.31-.139.67.04.97 .18.29.5.47.85.47h18c.34 0 .66-.18.85-.48 .18-.3.19-.67.04-.98ZM11 10h2v6h-2v-6Zm1 9.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25 -.56 1.25-1.25 1.25Z"/></svg>`
};
